export const dotFormatter = (value: number, precision?: number): string => {
  if (!value) return '0';
  const formatted = precision ? value.toFixed(precision) : value.toString();
  return formatted.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
};

export const roundNumber = (value: number, precision = 2): number => {
  const isInteger = Number.isInteger(value);
  if (isInteger || !precision) return value;
  return Math.trunc(value * 10 ** precision) / 10 ** precision;
};

export const convertAmount = (coinAmount: number, rate: number, precision = 2): number => {
  return roundNumber(coinAmount / rate, precision);
};

export const animateNumber = (element: HTMLDivElement | null, start: number, end: number, duration: number, precision = 2) => {
  let startTimestamp: number = 0;
  const step = (timestamp: number) => {
    if (!startTimestamp) startTimestamp = timestamp;
    const progress = Math.min((timestamp - startTimestamp) / duration, 1);
    if (element) {
      const value = (progress * (end - start) + start).toFixed(precision);
      element.innerHTML = `${dotFormatter(+value, precision)}`;
    }
    if (progress < 1) {
      window.requestAnimationFrame(step);
    }
  };
  window.requestAnimationFrame(step);
};
